<template>
	<div class="flex flex-col">
		<transition name="fade" mode="out-in">
			<div class="relative p-4 sm:p-6">
				<div
					v-if="Object.keys(errors).length"
					class="mb-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded"
				>
					<p v-for="(error, key) in errors" :key="key">{{ error }}</p>
				</div>
				<router-view />
				<div
					v-if="$route.name !== 'PaymentConfirmationComponent'"
					class="flex justify-between mt-6 sm:mt-8"
				>
					<!-- <button
            @click="handlePreviousStep"
            class="flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white/90 backdrop-blur-sm border border-white/30 rounded-lg hover:bg-white/95"
          >
            <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
            </svg>
            Previous
          </button> -->
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
	name: 'PaymentConfirmationPage',
	computed: {
		...mapState('insurance/motorPrivate', ['errors']),
	},
	methods: {
		...mapActions('insurance/motorPrivate', ['clearErrors']),
		handlePreviousStep() {
			this.$router.go(-1);
		},
	},
	mounted() {
		this.clearErrors();
	},
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
